module.exports = __webpack_public_path__ + "static/media/bars.8e698339.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/images/teachers/noticeboard/bars.svg
// module id = 562
// module chunks = 0